import { Button, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { useSelector } from "react-redux";
import { makeUpCategoryRequest } from '../../helpers/categoryRequest';
import { Category, CategoryListState } from '../../types/categories';
import ImagesField from '../common/imagesField/ImagesField';

interface Props {
    title: string;
    closeModal: () => void;
    refresh(page: number, perPage: number, field: string, order: string, title: string, filter: string)
    parentState: CategoryListState;
    isSub: boolean;
    category: Category | undefined
}

interface SelectCategories {
    id: string;
    title: string;
    _id?: string;
}

const EditCategory: FC<Props> = ({ title, closeModal, isSub, category, parentState, refresh }) => {

    const stateApp = useSelector((state) => state);
    const dataProvider = useDataProvider();
    const notify = useNotify()

    const [state, setState] = useState({
        isActive: true,
        title: '',
        isError: false,
        categories: Array<SelectCategories>(),
        selectedCategory: { id: '', title: '' }
    })

    useEffect(() => {
        if (category) {
            if (isSub) {
                getCategories(category)
            } else {
                setState({ ...state, isActive: category.isActive, title: category.title })
            }
        }
    }, [])

    const getCategories = async (category: Category) => {
        const categories = await dataProvider.getCategories('prizeCategories', {
            filter: { email: '', isActive: "all"},
            pagination: { page: 1, perPage: 1000 },
            sort: { field: "id", order: "asc" },
        }) as any;
        setState({
            ...state,
            categories: categories.data,
            selectedCategory: { title: category.categorytitle, id: category.categoryid },
            isActive: category.isActive || false,
            title: category.title
        })
    }

    const changeStatus = () => {
        setState({ ...state, isActive: !state.isActive })
    }
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.value.length > 50) {
            return
        }
        setState({ ...state, title: event.currentTarget.value })
    }

    const handleSelect = (event) => {
        let selectedProduct = { id: event.nativeEvent.target.id, title: event.target.value }
        setState({ ...state, selectedCategory: selectedProduct })
    }

    const saveCategory = async () => {
        const imageFile = stateApp.property.galleryFiles
        if (imageFile.length === 0) {
            setState({ ...state, isError: true })
            return
        }
        const data = isSub
            ? { title: state.title, photoUrl: imageFile[0], category: state.selectedCategory.id, isActive: state.isActive }
            : { title: state.title, photoUrl: imageFile[0], isActive: state.isActive }
        const multipartData = makeUpCategoryRequest(data)
        const result = isSub
            ? await dataProvider.update("subcategories",
                {
                    data: multipartData,
                    id: category ? category._id : '',
                    previousData: {} as any
                }
            )
            : await dataProvider.update("prizeCategories",
                {
                    data: multipartData,
                    id: category ? category._id : '',
                    previousData: {} as any
                }
            )
        if (result.data) {
            notify(`${isSub ? "Sub-category" : "Category"} updated`, "info")
            refresh(parentState.page, parentState.perPage, parentState.field, parentState.order, parentState.category, 'all')
            closeModal()
        }
    }

    return (
        <>
            <Box>
                <Box display="flex" justifyContent="center">
                    <Typography variant="h6" className="base-color">
                        Edit {title}
                    </Typography>
                </Box>
                <Box paddingRight="30em" paddingTop="3em">
                    <ImagesField error={state.isError} isSingle={true} awsFolder="prizePhotos" imagesKey={[category ? category.photoUrlKey : '']} />
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="center" width="50%" marginBottom="2em">
                    <Typography className="base-color">
                        Status
                </Typography>
                    <label className="switch checkbox-margin">
                        <input type="checkbox" checked={state.isActive} onChange={changeStatus} />
                        <span className="slider round"></span>
                    </label>
                </Box>
                {state.categories.length > 0 && isSub
                    &&
                    <Box display="flex" justifyContent="flex-start" alignItems="center" padding="1em 0">
                        <Typography className="base-color">
                            Category
                                </Typography>
                        <Select
                            id="search-input"
                            value={state.selectedCategory.title}
                            onChange={handleSelect}
                            name="subCategory"
                        >
                            {state.categories.map((category) => {
                                return (
                                    <MenuItem key={category._id} id={category._id} value={category.title} >
                                        {category.title}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </Box>
                }
                <Box display="flex" justifyContent="flex-start" alignItems="baseline" width="50%">
                    <Typography gutterBottom className="base-color">
                        Title
                </Typography>
                    <TextField
                        onChange={handleChange}
                        name='name'
                        value={state.title}
                        className="referral-fields"
                        label=""
                    />
                </Box>
                <Box display="flex" justifyContent="space-evenly" padding="2em" >
                    <Button
                        className="user-cancel-button user-modal-buttons"
                        disabled={!state.title}
                        onClick={saveCategory}>Save</Button>
                    <Button className="user-cancel-button user-modal-buttons" onClick={closeModal}>Cancel</Button>
                </Box>
            </Box>
        </>
    )
}

export default EditCategory